module.exports = __webpack_public_path__ + "eafa8be726aa9a6b214a48bbd11582bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footer/i-phone@2x.png
// module id = 1807
// module chunks = 1